export default __webpack_public_path__ + "static/media/logo-inm.5e47d71a.png";